import { Tab } from '../../types/chat';
export const loadTabsFromStorage = ({ STORAGE_KEY }: { STORAGE_KEY: string }): Tab[] => {
  const savedTabs = localStorage.getItem(STORAGE_KEY);
  if (savedTabs) {
    const parsedTabs = JSON.parse(savedTabs);
    return parsedTabs.map((tab) => ({
      ...tab,
      messages: tab.messages.map((msg) => ({
        ...msg,
        timestamp: msg.timestamp ? new Date(msg.timestamp) : new Date(),
      })),
    }));
  }
  return [];
};
